<template>
  <div class="vocabulary">
    <testHeader
      v-if="fromType !== 'hsk'"
      :testType="computedTestType"
      :currentLevelIndex="computedLevelIndex"
    ></testHeader>

    <!-- title+search -->
    <div class="tools">
      <div class="title-box">
        <!-- <div class="title">
          {{ $t("vocab_level_word", { level: `${filterTestType() + " " + Number(computedLevelIndex)}` }) }}
        </div> -->
        <!-- {{ computedLeftLevelList }} -->
        <div
          v-for="item in computedLeftLevelList"
          :key="item.id"
          :class="['level-card', { active: activeLevelIdsList.includes(item.id) }]"
          @click="changeLevel(item.id)"
        >
          <div>{{ item.level_name }}</div>
        </div>
        <span class="total">{{ $t('vocab_total_item', { total: total }) }}</span>
      </div>
      <div class="tools-download" @click="download" ref="loadingRef">
        <SvgIcon
          type="download_vocab"
          class="icon"
          style="width: 14px; height: 14px; margin-right: 5px; vertical-align: middle"
        />
        <!-- <i class="el-icon-download operation-left-btn-icon"></i> -->
        <span>{{ $t('download') }}</span>
      </div>
      <div class="tools-area">
        <el-input
          v-model="val"
          size="small"
          style="width: 200px"
          :placeholder="$t('vocab_search')"
          clearable
          @keydown.enter.native="handleSearch"
        >
          <i
            class="el-icon-search el-input__icon"
            slot="suffix"
            style="cursor: pointer"
            @click="handleSearch"
          >
          </i>
        </el-input>

        <el-select
          v-model="val1"
          size="small"
          class="select-box"
          @change="changeMarkSelect"
          popper-class="mark-select"
        >
          <!-- <template slot="prefix">
            <el-tooltip class="item" effect="dark" placement="top-start" @click.native.stop>
              <div slot="content">{{ $t("mark_free") }}</div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template> -->
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <span @click="handlerAddClick"
          ><SvgIcon type="add" class="icon" v-if="isEditorOrAdmin"
        /></span>
        <!-- 下载图标 -->
        <!-- <SvgIcon type="download" class="icon" /> -->
      </div>
    </div>
    <!-- 选字母 -->
    <div class="pager" v-if="letterArr.length > 0">
      <div @click="clickPrev">
        <SvgIcon type="left-arrow" class="pager-icon" />
      </div>
      <div
        v-for="(item, index) in letterArr"
        :key="index"
        :class="[{ active: isActive === index }, 'letter-btn', { 'is-first': index == 0 }]"
        @click="clickLetter(index)"
      >
        {{ item }}
      </div>

      <div @click="clickNext">
        <SvgIcon type="right-arrow" class="pager-icon" />
      </div>
    </div>
    <!-- table -->
    <div class="tabler" v-if="tableData.length > 0">
      <el-table
        :header-row-style="setHeaderStyle"
        :data="tableData"
        @row-click="handlePreview"
        :row-style="{ cursor: 'pointer' }"
      >
        <el-table-column :label="$t('vocabulary')" width="150" prop="word" fixed>
          <template slot-scope="scope">
            <span class="vocab-word">{{ scope.row.word }}</span></template
          ></el-table-column
        >
        <el-table-column :label="$t('vocab_pinyin')" width="216">
          <template slot="header">
            <span style="margin-left: 24px">{{ $t('vocab_pinyin') }}</span>
          </template>
          <template slot-scope="scope">
            <a href="#" @click.stop="handlePlay(scope.row)"
              ><SvgIcon
                :type="scope.row.isPinyinPlay === false ? 'pause' : 'play'"
                class="tabler-icon"
                style="margin-left: -10px; width: 21px; height: 21px; margin-bottom: -1px"
            /></a>
            <span class="pinyin">{{ scope.row.pinyin_tone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('vocab_type')"
          width="80"
          prop="syntax"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="$t('vocab_translate')"
          min-width="376"
          prop="translation"
          show-overflow-tooltip
        ></el-table-column>
        <!-- level -->
        <el-table-column :label="$t('level')" min-width="296" align="left" header-align="left">
          <template slot-scope="scope">
            <div class="level_box">
              <!-- v-for="(item,index) in scope.row.levels" :key="index" :levelType="item.type_name" :levelNum="item.level_id"-->
              <level
                class="level_item"
                v-for="item in scope.row.levels"
                :key="item.id"
                :levelType="item.type_name"
                :levelNum="item.level_id"
              ></level>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('vocab_mark')" width="96">
          <template slot-scope="scope">
            <a href="#" @click.stop="toggleMarkStar(scope.row)">
              <SvgIcon
                v-if="scope.row.is_peg === 1"
                type="plain-star_yellow"
                class="tabler-icon"
                style="color: #fac856; width: 18px; height: 18px" />
              <SvgIcon
                v-else
                type="star_grey"
                class="tabler-icon"
                style="width: 18px; height: 18px"
            /></a>
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template slot-scope="scope">
            <div class="p-r-8">
              <span @click.stop="handleEdit(scope)" v-if="isEditorOrAdmin"
                ><SvgIcon type="edit" class="tabler-icon"
              /></span>
              <span @click.stop="handleDelete(scope.$index, scope.row)" v-if="isEditorOrAdmin"
                ><SvgIcon type="delete" class="tabler-icon"
              /></span>
              <span @click.stop="handlePreview(scope.row)"
                ><SvgIcon type="preview" class="tabler-icon" style="margin-right: 0"
              /></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <empty-content v-else :loading="false" class="empty-content" />
    <!-- 编辑词汇 -->
    <EditDialog
      :dialogType="editType"
      :editorDialogVisible="editorDialogVisible"
      :editorDialogInfo="editorDialogInfo"
      @cancClick="editClickCanc"
      @editClick="editClickSave"
      @addClick="addClickSave"
      ref="editDialog"
    />
    <!-- 查看弹窗 -->
    <PreviewDialog
      :viewDialogVisible="viewDialogVisible"
      :isZi="isZi"
      :backList="backList"
      :ziWritingFullInfo="ziWritingFullInfo"
      :ziWritingSameRadicalList="ziWritingSameRadicalList"
      :ziSpeakingSameSoundList="ziSpeakingSameSoundList"
      :ziSpeakingSamilarSoundList="ziSpeakingSamilarSoundList"
      :ziMeaningList="ziMeaningList"
      :ziMeaningSentence="ziMeaningSentence"
      :wordGroupList="wordGroupList"
      :meaningCount="meaningCount"
      @close="close"
      @clickViewToDetail="clickViewToDetail"
      @clickBackToDetail="clickBackToDetail"
      @getWordDetailWriting="getWordDetailWriting"
      @handlePlay="handlePlay"
      @getWordGroupDetail="getWordGroupDetail"
      @getWordsList="getWordsList"
    />
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="getWordListParams.page_num"
      :page-sizes="[10, 50, 100, 200, 300]"
      :page-size="getWordListParams.page_size"
      layout="sizes, prev, pager, next"
      :total="total_count"
      class="class-pagination"
      v-if="total_count > 0"
    >
    </el-pagination>
  </div>
</template>

<script>
import level from './components/levels'
import { testConfig } from '@/config'
import testHeader from '@/components/hsk/common/testHeader.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import EditDialog from '@/components/vocabulary/EditDialog.vue'
import PreviewDialog from '@/components/vocabulary/PreviewDialog'
import { highlightKeyword } from '@/utils/helper'
import { apiRequest, utilV2 } from '@/serves/http'
import ApiPath from '@/serves/path'
import { setLastPage, getToken } from '@/utils/cache'
import { debounce } from 'throttle-debounce'
import { mapState, mapGetters } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import { mixinMixpanel } from '@/mixins'
import { downloadFile } from '@/utils/utils'
import { Loading } from 'element-ui'
import { getTestType } from '@/utils/hskTool'
export default {
  props: {
    fromType: {
      type: String,
      default: () => '',
    },
  },
  name: 'Vocabulary',
  components: {
    testHeader,
    SvgIcon,
    EditDialog,
    PreviewDialog,
    level,
  },
  mixins: [mixinMixpanel],
  data() {
    // 已标记未标记切换
    this.selectOptions = [
      { label: this.$t('vocab_all_marked'), value: 0 },
      { label: this.$t('vocab_already_marked'), value: 1 },
      { label: this.$t('vocab_unmarked'), value: 2 },
    ]
    return {
      val: '',
      val1: 0,
      tableData: [],
      total: 0, //数据总个数
      letterArr: [
        'ALL',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
      ],
      isActive: 0, //字母初始的时候默认为A
      editorDialogVisible: false, //编辑/添加词汇弹窗是否显示
      editorDialogInfo: {}, //编辑/添加词汇弹窗具体信息
      editType: 1,
      viewDialogVisible: false, //查看弹窗是否显示
      // level_id: 1,
      // 请求详情页的参数
      getWordListParams: {
        level_ids: [],
        initial: '',
        keyword: '',
        is_peg: null,
        page_num: 1,
        page_size: 10,
      },
      wordListIs_peg: null,
      deleteId: null, //要删除字词的id
      isZi: true, //是字还是词
      backList: [], //返回显示的字词队列
      ziWritingFullInfo: {}, //详情弹窗字writing信息
      ziWritingSameRadicalList: [], //详情弹窗字writing同部首字信息
      ziSpeakingSameSoundList: {}, //详情页speaking同音数组
      ziSpeakingSamilarSoundList: [], //详情页speaking相似音数组
      ziMeaningList: [], //详情页meaning词组
      ziMeaningSentence: [], //详情页例句
      // ziMeaningMoreSentence: [], // 例句加载更多数据
      meaningCount: 0, //词组个数
      wordGroupList: {}, //词语详情页{}
      sound: null,
      activeLevelIdsList: [],
      total_count: 0,
    }
  },
  watch: {
    levelActive: {
      handler() {
        this.activeLevelIdsList = [this.computedLevelId]
      },
      immediate: true,
    },
    activeLevelIdsList: {
      handler() {
        this.getAllWords()
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      role: (state) => state.user.role,
      levelList: (state) => state.level.levelList,
      levelActive: (state) => state.level.levelActive,
      levelType: (state) => state.level.levelType,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    ...mapGetters('level', {
      // 获取考试类型
      typeName: 'levelActiveObj',
    }),
    isEditorOrAdmin() {
      if (this.$store.state.user.role === 'admin' || this.$store.state.user.role === 'editor') {
        return true
      } else {
        return false
      }
    },
    computedLevelId() {
      let level_num = +this.$route.query.level.match(/\d+/)?.[0] || 1
      let level_type = this.getLevelTypeByRoute()
      let levelList = this.levelList.find((item) => item.level_type == level_type)
      return levelList?.levels.find((item) => level_num == item.level_id)?.id || null
      // return Number(this.levelActive || localStorage.getItem('LevelActive'))
    },
    computedTestType() {
      return Number(this.levelType || localStorage.getItem('LevelType'))
    },
    computedLevelIndex() {
      return Number(this.levelActiveIndex || localStorage.getItem('LevelActiveId'))
    },
    computedLeftLevelList() {
      // 查找当前等级剩余的等级信息
      console.log('this.levelList', this.levelList)
      let result
      for (let i = 0; i < this.levelList.length; i++) {
        for (let j = 0; j < this.levelList[i].levels.length; j++) {
          if (this.levelList[i].levels[j].id == this.computedLevelId) {
            result = this.levelList[i].levels.slice(0, j + 1)
          }
        }
      }
      return result?.reverse()
    },
  },
  methods: {
    getLevelTypeNameByRoute() {
      let path = window.location.pathname || this.$route.path
      return path.split('/')[1]
    },
    getLevelTypeByRoute() {
      let typestr = this.getLevelTypeNameByRoute()
      return getTestType(typestr)
    },
    //词汇大纲浏览埋点
    buriedPoint(alphabet, searchbox, bookmark) {
      let mixpanelParams = {
        people_id: this.peopleId,
        unlimited: this.unlimited,
        searchbox: searchbox,
        alphabet: alphabet,
        exam_type: this.typeName.level_name,
      }
      !mixpanelParams.searchbox && delete mixpanelParams.searchbox
      analytics.logEvent('hskweb_syllabus_view', mixpanelParams)
    },
    // 格式化level_type
    filterTestType() {
      const compare = (a, b) => a == b
      return Object.keys(testConfig).find((item) =>
        compare(testConfig[item], this.computedTestType)
      )
    },
    // 设置表头
    setHeaderStyle() {
      return {
        'font-size': '12px',
        color: '#B5B5BE',
        'line-height': '10px',
        padding: '0px',
        height: '20px',
      }
    },
    //没登陆的话跳转到登录页面
    toLogin() {
      setLastPage(this.$route.path)
      this.$store.dispatch('user/handleLogout', { reLogin: true })
    },
    // 搜索
    handleSearch() {
      this.getWordListParams.page_num = 1
      this.getWordListParams.keyword = this.val
      this.getAllWords(this.val)
    },
    //更改标记选择下拉框的值
    changeMarkSelect(selectIndex) {
      let type = ''
      this.getWordListParams.page_num = 1
      if (selectIndex === 0) {
        //下拉框埋点
        type = 'All'
        this.getWordListParams.is_peg = null
      } else if (selectIndex === 1) {
        //下拉框埋点
        type = 'Bookmarked'
        this.getWordListParams.is_peg = 1
      } else if (selectIndex === 2) {
        //下拉框埋点
        type = 'Not bookmarked'
        this.getWordListParams.is_peg = 0
      }
      this.getAllWords(this.val, type)
    },
    //添加=========
    //点击添加词汇
    handlerAddClick() {
      this.editType = 1
      this.editorDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editDialog.$refs.firstInp.focus()
      })
    },

    // 点击切换字母
    clickLetter(index) {
      this.isActive = index
      this.getWordListParams.page_num = 1
      this.getWordListParams.initial =
        this.letterArr[this.isActive] == 'ALL' ? '' : this.letterArr[this.isActive]
      this.getWordsList()
      //埋点
      this.buriedPoint(this.letterArr[this.isActive] ?? '')
    },
    // 点击上一个字母
    clickPrev() {
      this.getWordListParams.page_num = 1
      if (this.isActive > 0) {
        this.isActive--
        console.log(this.letterArr, this.isActive)
        this.getWordListParams.initial =
          this.letterArr[this.isActive] == 'ALL' ? '' : this.letterArr[this.isActive]
        this.getWordsList()
        //埋点
        this.buriedPoint(this.letterArr[this.isActive] ?? '')
      } else {
        this.isActive = 0
      }
    },
    // 点击下一个字母
    clickNext() {
      this.getWordListParams.page_num = 1
      if (this.isActive < this.letterArr.length - 1) {
        this.isActive++
        this.getWordListParams.initial =
          this.letterArr[this.isActive] == 'ALL' ? '' : this.letterArr[this.isActive]
        this.getWordsList()
      } else {
        this.isActive = this.letterArr.length - 1
        //埋点
        this.buriedPoint(this.letterArr[this.isActive] ?? '')
      }
    },
    // 点击标记的星星
    toggleMarkStar(row) {
      const token = getToken()
      if (token) {
        if (row.is_peg === 1) {
          this.unMarkWord(row.id)
        } else {
          this.markWord(row.id)
        }
      } else {
        this.toLogin()
      }
    },
    // 点击编辑
    handleEdit(scope) {
      this.editType = 2
      this.editorDialogVisible = true
      this.editorDialogInfo = scope.row
      this.$nextTick(() => {
        this.$refs.editDialog.$refs.firstInp.focus()
        this.$refs.editDialog.remainder()
      })
    },
    //编辑、添加之后点击取消
    editClickCanc() {
      this.editorDialogVisible = false
      this.editorDialogInfo = {}
    },
    //编辑之后点击保存
    editClickSave() {
      this.editorDialogVisible = false
      this.editorDialogInfo = {}
      // this.getWordsList();
      this.getAllWords()
    },
    //添加之后点击保存
    addClickSave() {
      this.editorDialogVisible = false
      this.editorDialogInfo = {}
      this.getAllWords()
    },

    // 点击删除
    handleDelete(index, row) {
      const h = this.$createElement
      this.deleteId = row.id
      this.$msgbox({
        title: this.$t('delete_confirmation'),
        message: h('p', null, [h('span', null, row.word)]),
        showCancelButton: true,
        confirmButtonText: this.$t('del'),
        cancelButtonText: this.$t('cancel'),
        center: true,
        customClass: 'vocab_del_box',
        showClose: false,
        confirmButtonClass: 'del-button',
        cancelButtonClass: 'canc-button',
      })
        .then(() => {
          this.deleteWord()
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    // 点击查看======
    //点击查看按钮
    handlePreview(row) {
      console.log(row, 'row')
      const token = getToken()
      if (token) {
        setTimeout(() => {
          this.viewDialogVisible = true
        }, 300)
        this.clickViewToDetail(row.id, row.word, row.pinyin_num)
      } else {
        this.toLogin()
      }
    },

    //播放拼音音频
    handlePlay(row) {
      var soundUrl = row.tts_url || ''
      if (soundUrl) {
        if (row.isPinyinPlay) {
          this.$player.pause()
        } else {
          //第五个参数表示是否加时间戳，tts地址的音频由于后端限制，不能添加时间戳，否则不能正常播放
          //最后一个参数是是否判断为同一个音频，词汇处不需要
          this.$player.play(soundUrl, '', {}, false, false, false)
          row.isPinyinPlay = true
          console.log(this.$player)
        }

        this.$player.onpaused = () => {
          console.log('暂停了')
          row.isPinyinPlay = false
        }
        this.$player.onended = () => {
          row.isPinyinPlay = false
          console.log('自动结束')
        }
        this.$player.onUnload = () => {
          console.log('unloaded')
          row.isPinyinPlay = false
        }
        this.$player.onloaderrored = () => {
          row.isPinyinPlay = false
        }
      }
    },
    //关闭查看弹窗
    close() {
      this.viewDialogVisible = false
      this.backList = []
      if (this.$player) {
        this.$player.stop()
      }
    },
    // 请求搜索数据切换字母，不需要更新索引
    getWordsList: debounce(500, function () {
      this.getWordListParams.keyword = this.val
      this.getWordListParams.initial =
        this.letterArr[this.isActive] == 'ALL' ? '' : this.letterArr[this.isActive]
      console.log('请求数据了', this.getWordListParams)
      if (this.getWordListParams.is_peg === null) {
        delete this.getWordListParams.is_peg
      }
      apiRequest
        .post(ApiPath.get_vocab_detail, this.getWordListParams, { loading: true })
        .then((res) => {
          this.total = res.data.level_count
          this.total_count = res.data.total_count
          if (res.data.list) {
            this.tableData = this.formatArr(res.data.list)
          } else {
            this.tableData = []
          }
        })
    }),

    //请求该词汇列表数据 更新索引（搜索和切换标记状态使用，添加词汇也使用）
    getAllWords(point, type) {
      this.getWordListParams.keyword = this.val
      if (this.getWordListParams.is_peg === null) {
        delete this.getWordListParams.is_peg
      }
      this.getWordListParams.level_ids = this.activeLevelIdsList
      // console.log('this.isActive', this.isActive)
      this.getWordListParams.initial = ''
      // console.log('this.getWordListParams', this.getWordListParams)
      apiRequest
        .post(ApiPath.get_vocab_detail, this.getWordListParams, { loading: true })
        .then((res) => {
          this.isActive = 0
          this.tableData = []
          this.total_count = res.data.total_count
          if (res.data.list) {
            //当前选中的字母索引activeWord
            const activeWord = this.letterArr[this.isActive]
            //如果新的letterArr索引数组中包含activeWord，保持选中当前索引，否则默认选择第一个字母
            this.isActive = this.letterArr.findIndex((item) => item === activeWord)
            if (this.isActive < 0) {
              this.isActive = 0
            }
            console.log(this.letterArr[this.isActive], 'activeLetter')
            //初始埋点
            if (this.getWordListParams.page_num == 1) {
              this.buriedPoint(this.letterArr[this.isActive] ?? '', point, type)
            }
            this.getWordListParams.initial = this.letterArr[this.isActive] ?? ''
            let wordLst = res.data.list
            this.tableData = this.formatArr(wordLst)
            this.total = res.data.level_count
          }
        })
    },

    // 标记/收藏接口
    markWord(id) {
      console.log('发送请求标记词', id)
      apiRequest.post(ApiPath.peg_word, { id, is_peg: 1 }).then((res) => {
        console.log(res)
        this.getWordsList()
      })
    },
    //取消标记/收藏接口
    unMarkWord(id) {
      console.log('发送请求取消标记词', id)
      apiRequest.post(ApiPath.peg_word, { id, is_peg: 0 }).then((res) => {
        console.log(res)
        this.getWordsList()
      })
    },
    //删除词汇接口
    deleteWord() {
      let params = {
        id: this.deleteId,
      }
      console.log('删除词汇id', params)
      window.utilV2
        .getData(ApiPath.delete_word, params, (res) => {
          console.log(res)
          this.$message({
            message: this.$t('del_success'),
            type: 'success',
          })
          // this.getWordsList();
          this.getAllWords()
        })
        .catch(() => {
          this.$message.error(this.$t('del_fail'))
        })
    },
    //判断是字词并展示对应弹窗(点击字词去查看)
    clickViewToDetail(id, word, pinyin_num) {
      this.addBackList(id, word, pinyin_num)
      console.log(this.backList)
      const params = { id, word, pinyin_num }
      if (word.length > 1) {
        setTimeout(() => {
          this.isZi = false
        }, 700)
        this.getWordGroupDetail(params)
      } else {
        setTimeout(() => {
          this.isZi = true
        }, 700)
        this.getWordDetailWriting(params)
        this.getWordDetailSpeaking(params)
        this.getWordDetailMeaning(params)
      }
    },
    //通过返回按钮查看字词详情
    clickBackToDetail(id, word, pinyin_num) {
      this.reduceBackList()
      const params = { id, word, pinyin_num }
      // 词
      if (word.length > 1) {
        console.log('需要请求词汇详情---返回')
        setTimeout(() => {
          this.isZi = false
        }, 700)
        this.getWordGroupDetail(params)
        // 字
      } else {
        setTimeout(() => {
          this.isZi = true
        }, 700)
        this.getWordDetailWriting(params)
        this.getWordDetailSpeaking(params)
        this.getWordDetailMeaning(params)
      }
    },
    //格式化数组 给数组中的内一个对象添加isPinyinPlay字段
    formatArr(arr) {
      return arr.map((item) => {
        if (item.levels) {
          item.levels = item.levels.reduce((acc, item) => {
            // 检查是否已经有当前type_name的项
            const existing = acc.find((x) => x.type_name === item.type_name)
            // 如果不存在，或存在但当前项的level_type更小，则更新/添加到累加器中
            if (!existing || item.level_type < existing.level_type) {
              // 移除已有的项（如果存在且当前项的level_type更小）
              const filteredAcc = existing ? acc.filter((x) => x.type_name !== item.type_name) : acc
              // 添加/更新项
              return [...filteredAcc, item]
            }
            return acc
          }, [])
        }
        return { ...item, isPinyinPlay: false }
      })
    },
    //获取文字明细接口-writing
    getWordDetailWriting(params) {
      utilV2.getData(ApiPath.get_vocab_writing, params, (res) => {
        this.ziWritingFullInfo = { ...res, isPinyinPlay: false }
        if (res.writting) {
          this.ziWritingSameRadicalList = res.writting.map((item) => {
            return { ...item, radical_chars: this.formatArr(item.radical_chars) }
          })
        } else {
          this.ziWritingSameRadicalList = []
        }
        console.log('ziWritingFullInfo', this.ziWritingFullInfo)
        console.log('ziWritingSameRadicalList', this.ziWritingSameRadicalList)
      })
    },
    //获取文字明细接口-speaking
    getWordDetailSpeaking(params) {
      utilV2.getData(ApiPath.get_vocab_speaking, params, (res) => {
        console.log(res, 'speaking')
        //同音
        this.ziSpeakingSameSoundList = {
          ...res.speaking.sound_same_words,
          isPinyinPlay: false,
          samilar_count: res.speaking.samilar_count,
        }
        if (res.speaking.sound_same_words.chars) {
          this.ziSpeakingSameSoundList.chars = this.formatArr(this.ziSpeakingSameSoundList.chars)
        }
        //近音
        this.ziSpeakingSamilarSoundList = []
        if (res.speaking.sound_samilar_pinyins) {
          this.ziSpeakingSamilarSoundList = this.formatArr(res.speaking.sound_samilar_pinyins)
          this.ziSpeakingSamilarSoundList = this.ziSpeakingSamilarSoundList.map((item) => {
            return { ...item, chars: this.formatArr(item.chars) }
          })
        }
      })
    },
    //获取文字明细接口-meaning
    getWordDetailMeaning(params) {
      utilV2.getData(ApiPath.get_vocab_meaning, params, (res) => {
        console.log(res)
        this.meaningCount = res.meaning.count
        this.ziMeaningSentence = (res?.meaning?.sentences || []).map((item) => {
          return {
            ...item,
            isPinyinPlay: false,
          }
        })
        if (res.meaning.as_in_words === null) {
          this.ziMeaningList = []
        } else {
          setTimeout(() => {
            if (res.meaning.as_in_words) {
              this.ziMeaningList = this.formatArr(res.meaning.as_in_words).map((item) => {
                return {
                  ...item,
                  word: highlightKeyword(item.word, this.ziWritingFullInfo.word),
                  pinyin_tone: highlightKeyword(
                    item.pinyin_tone,
                    this.ziWritingFullInfo.pinyin_tone
                  ),
                }
              })
            }
            console.log(this.ziMeaningList, 'ziMeaningList')
          }, 200)
        }
      })
    },
    //获取词汇详情
    getWordGroupDetail(params) {
      utilV2.getData(ApiPath.get_word_group_detail, params, (res) => {
        console.log(res)
        this.wordGroupList = { ...res, isPinyinPlay: false }
        if (this.wordGroupList.sentences) {
          this.wordGroupList.sentences = this.formatArr(this.wordGroupList.sentences).map(
            (item) => {
              console.log(
                highlightKeyword(item.sentence, this.wordGroupList.word),
                highlightKeyword(item.pinyin_tone, this.wordGroupList.pinyin_tone)
              )
              return {
                ...item,
                sentence: highlightKeyword(item.sentence, this.wordGroupList.word),
                pinyin_tone: highlightKeyword(item.pinyin_tone, this.wordGroupList.pinyin_tone),
              }
            }
          )
        }
        if (this.wordGroupList.chars) {
          this.wordGroupList.chars = this.formatArr(this.wordGroupList.chars)
        }
        console.log('wordGroupList', this.wordGroupList)
      })
    },
    //队列增加
    addBackList(id, word, pinyin_num) {
      if (word.includes('span') > -1) {
        word = word.replace(/<[^>]+>/g, '')
        console.log(word)
      }
      this.backList.push({ id, word, pinyin_num })
    },
    //队列减少
    reduceBackList() {
      this.backList.pop()
      console.log(this.backList, '减少')
    },
    changeLevel(id) {
      this.getWordListParams.page_num = 1
      if (this.computedLevelId === id) return
      this.isActive = ''
      if (this.activeLevelIdsList.includes(id)) {
        let index = this.activeLevelIdsList.findIndex((item) => item == id)
        this.activeLevelIdsList.splice(index, 1)
      } else {
        this.activeLevelIdsList.push(id)
      }
    },
    //切换每一页的长度
    handleSizeChange(val) {
      this.getWordListParams.page_size = val
      this.getWordListParams.page_num = 1
      this.getAllWords()
    },
    //切换分页
    handleCurrentChange(val) {
      this.getWordListParams.page_num = val
      // this.getAllWords()
      this.getWordsList()
    },
    download() {
      console.log('this.getWordListParams', this.getWordListParams)
      try {
        const { level_ids, initial, keyword, is_peg } = this.getWordListParams
        const params = {
          level_ids,
          initial: initial === 'ALL' ? '' : initial,
          keyword,
          is_peg,
        }
        apiRequest.post(ApiPath.get_vocab_download_task_id, params).then((res) => {
          if (res.errcode === 0) {
            this.getExportTaskStatus(res.data.task_id)
          }
        })
      } catch (error) {
        this.$message.error(error)
        throw error
      }
    },
    // 时间格式定制
    getCurrentTimeFormatted() {
      const now = new Date()

      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0') // 月份是从0开始的
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')

      return `${year}${month}${day}${hours}${minutes}`
    },
    //根据id，下载文件
    getExportTaskStatus(task_id) {
      const loadingInstance = Loading.service({ target: this.$refs.loadingRef })
      const params = {
        task_id: task_id,
      }
      try {
        apiRequest
          .get(ApiPath.vocab_download, { params }, { loading: true })
          .then((res) => {
            console.log('-----------导出', res.data)
            if (res.errcode === 0 && res.data.file_url) {
              let { file_url } = res.data
              const fileName = `HSK词汇下载${this.getCurrentTimeFormatted()}`
              downloadFile(file_url, fileName)
            }
          })
          .finally(() => {
            loadingInstance.close()
          })
      } catch (error) {
        this.$message.error(error)
        throw error
      }
    },
  },
  beforeDestroy() {
    if (this.$play) {
      this.$player.stop()
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.vocabulary {
  // width: 1200px;
  margin: 0 auto;
  .tools {
    display: flex;
    // justify-content: space-between;
    .title-box {
      display: flex;
      flex: 1;
      // width: 65%;
      .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 33px;
      }
      .total {
        line-height: 34px;
        font-size: 12px;
        font-weight: 400;
        color: #b5b5be;
        margin-left: 12px;
      }
      .level-card {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 62px;
        height: 34px;
        border-radius: 20px;
        background: #b5b5be;
        color: #fff;
        margin-left: 10px;
        cursor: pointer;
        &:first-child {
          margin: 0;
        }
        &:hover {
          background: #faae56;
        }
      }
      .active {
        background: #faae56;
      }
    }
    .tools-download {
      line-height: 34px;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        // color: #faae56;
      }

      &::v-deep .el-loading-spinner .path {
        stroke: #faae56;
      }
    }

    &-area {
      .icon-search {
        width: 14px;
        height: 14px;
        background-image: url(@/assets/images/search.png);
      }
      .icon {
        width: 20px;
        height: 20px;
        margin-left: 16px;
        transform: translateY(5px);
        cursor: pointer;
      }
    }
  }
  .pager {
    display: flex;
    justify-content: space-between;
    margin: 17px 0;
    &-icon {
      width: 10px;
      height: 10px;
      cursor: pointer;
    }

    .letter-btn {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #fff;
      line-height: 20px;
      text-align: center;
      transform: translateY(-5px);
      cursor: pointer;
      &.active {
        background: #faae56;
        color: #fff;
      }
    }
    .is-first {
      min-width: 36px;
      height: 20px;
      border-radius: 10px;
    }
  }
  .tabler {
    &-icon {
      width: 14px;
      height: 14px;
      margin-right: 14px;
      margin-top: 4px;
      cursor: pointer;
    }
    ::v-deep .cell {
      display: flex;
      align-items: center;
      word-break: break-word;
    }
  }
}

@media screen and (max-width: 768px) {
  .vocabulary {
    .tools {
      flex-wrap: wrap;
      row-gap: 16px;

      .tools-area {
        width: 100%;
        display: flex;

        ::v-deep .el-input {
          flex: 1;
          min-width: 0;
        }

        & > div:nth-of-type(1) {


          & > input{
            line-height: 20px;
            ::placeholder {
              color: red !important;
            }
          }
        }

        & > div:nth-of-type(2) {

        }
      }

    }

    .pager {
      flex-wrap: wrap;
      row-gap: 8px;
      column-gap: 8px;
      justify-content: flex-start;

      .letter-btn {
        transform: none;
      }
    }
  }
}


.select-box {
  width: 120px;
  padding-left: 16px;
  ::v-deep .el-input__inner {
    padding-left: 15px;
    width: 100px;
    text-align: center;
    &:focus {
      border: 1px solid #2c2f46 !important;
    }
  }
}
::v-deep .el-icon-question::before {
  position: relative;
  left: 60px;
  top: 9px;
}
::v-deep .el-icon-question {
  width: 0;
  height: 0;
}
::v-deep .el-input__inner {
  // padding-top: 3px;
  &:focus {
    border: 1px solid #2c2f46 !important;
  }
}
::v-deep .tabler .vocab-word {
  font-weight: 600;
  color: #2c2f46;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
}
::v-deep .tabler th {
  padding: 5px 0 3px 0 !important;
  background: $background-color !important;
}
::v-deep .tabler td {
  padding: 5px 0 3px 0 !important;
  font-size: 16px !important;
  color: $grey !important;
}
::v-deep .tabler .el-table__body-wrapper {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
::v-deep .empty-content {
  margin-top: 150px;
}
::v-deep .el-table .cell.el-tooltip {
  width: 576px;
}
::v-deep .class-pagination {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  // height: 20px !important;
  padding-top: 16px;
  padding-bottom: 16px;
  border-left: 1px solid #efeff1;
  border-right: 1px solid #efeff1;
  border-bottom: 1px solid #efeff1;
  .el-select {
    font-size: 14px !important;
    color: #696974 !important;
    .el-input__inner {
      border: none;
      background: #fafafb;
      border-radius: 6px;
      &:focus {
        border: none !important;
      }
    }
  }
  .el-pagination__total,
  .slot {
    font-size: 12px !important;
    color: #b5b5be !important;
    font-weight: 400 !important;
    font-family: 'Inter';
    font-style: normal;
    line-height: 20px !important;
    padding-right: 20px;
  }
  .el-pagination__total {
    margin-right: 0;
  }

  .number,
  .more,
  .btn-prev,
  .btn-next {
    padding: 0;
    font-size: 12px !important;
    margin-right: 12px;
    width: 20px !important;
    height: 20px !important;
    line-height: 20px !important;
    background: #fafafb;
    border-radius: 50%;
    color: #696974;
    font-family: 'Inter';
    font-style: normal;
    min-width: 20px !important;
    &.active {
      color: #fff;
      background: #faae56;
    }
  }
}
.level_box {
  display: flex;
  // justify-content: flex-start;
  .level_item {
    margin-right: 28px;
  }
}
::v-deep .el-table__fixed,
.el-table__fixed-right {
  height: calc(100% - 8px) !important;
}
</style>
